var helpers = require('./helpers');

var jQueryBridget = require('jquery-bridget');

var Isotope = require('isotope-layout/dist/isotope.pkgd');

jQueryBridget('isotope', Isotope, $);
$(document).ready(function () {
  //Listeners
  // Filter Trigger
  $(window).on('change', onChange); // List with filters

  $('.option-set input').on('click', function () {
    var label = $(this).next('label').text().replace("'", '');

    if ($(this).is(':checked')) {
      $("<span>".concat(label, " /</span>'")).appendTo('.filters-current');
    } else {
      $('.filters-current').find("span:contains('".concat(label, " /')")).remove();
    }
  }); // All planned courses

  var planned_courses = $('#filtered_planned_courses'); // Search bar

  var search = $('.quicksearch'); //Filters

  var checkboxes = $('.filters input'); // Search bar regex

  function searchBar() {
    return new RegExp(quicksearch.val(), 'gi');
  } // Search through the planned courses


  var quicksearch = search.keyup(helpers.debounce(function () {
    planned_courses.isotope();
  }));

  function getGroups() {
    var groups = $('[data-group]').toArray();
    return groups.map(function (group) {
      return $(group).data('group');
    });
  }

  function lastCall() {
    var selected_planned_courses = initializeFilters();
    getGroups().forEach(function (filterGroup) {
      var options = get_options(filterGroup, selected_planned_courses, planned_courses_array);
      update_checkboxes(filterGroup, options.filterGroupOptions, options.filterGroupOptionsHide);
    });
  }

  function initializeFilters() {
    // Get the data groups
    var groups = $('[data-group]').toArray();
    return groups.map(function (group) {
      var element = $(group); // Get categoy name

      var filterCategory = $(group).data('group'); // Get checkbox per group

      var checkboxesGroup = element.find('input').toArray(); // If checkbox true put it in the group filter array

      var checkedValues = checkboxesGroup.filter(function (checkbox) {
        return checkbox.checked;
      }).map(function (checkbox) {
        return checkbox.value;
      });
      return {
        name: filterCategory,
        values: checkedValues
      };
    }).filter(function (group) {
      return group.values.length > 0;
    });
  } // Function for getting the filters that can lead to 0 results and the ones that have results


  function get_options(filterGroup, selectedFilters, planned_courses) {
    var planned_course_possibilities = planned_courses;
    selectedFilters.filter(function (selectedFilter) {
      return selectedFilter.name !== filterGroup;
    }).map(function (selectedFilter) {
      planned_course_possibilities = planned_course_possibilities.filter(function (planned_course) {
        return helpers.isSubsetOf(planned_course[selectedFilter.name], selectedFilter.values);
      });
    }); // Extract from the planned_course_possibilities the specific list of options for that filter

    var filterGroupOptions = planned_course_possibilities.flatMap(function (pc) {
      return pc[filterGroup];
    }).filter(helpers.distinct);
    var filterGroupOptionsOutsideCategory = planned_courses.flatMap(function (pc) {
      return pc[filterGroup];
    }).filter(helpers.distinct);
    var filterGroupOptionsHide = filterGroupOptionsOutsideCategory.filter(function (element) {
      return !filterGroupOptions.includes(element);
    });
    return {
      filterGroupOptions: filterGroupOptions,
      filterGroupOptionsHide: filterGroupOptionsHide
    };
  } // Function for hiding or showing the filters depending on the leading results


  function update_checkboxes(filterGroup, planned_courses_possibilities, planned_courses_possibilities_hide) {
    planned_courses_possibilities_hide.forEach(function (element) {
      var checkbox = "#".concat(element);

      if (element) {
        $(checkbox).prop('checked', false);
        $(checkbox).addClass('disable-option');
        $(checkbox + 'label').addClass('disable-option');
      }
    });
    planned_courses_possibilities.forEach(function (element) {
      var checkbox = "#".concat(element);

      if (element) {
        $(checkbox).removeClass('disable-option');
        $(checkbox + 'label').removeClass('disable-option');
      }
    });
  } // Remove hash from url


  function removeHash() {
    history.pushState('', document.title, window.location.pathname + window.location.search);
  } // Function for triggering the filtering, hide and show of filters and search


  function onChange() {
    var filterGroups = initializeFilters();
    var stringFilters = helpers.isotopeFilters(filterGroups);

    if (stringFilters.length > 0) {
      location.hash = "filter=".concat(encodeURIComponent(stringFilters));
    } else {
      removeHash();
    }

    lastCall();
    planned_courses.isotope({
      filter: function filter() {
        var searchResult = searchBar() ? $(this).text().match(searchBar()) : true;
        var filterResult = stringFilters ? $(this).is(stringFilters) : true;
        return filterResult && searchResult;
      }
    });
  }

  function getFilters() {
    var matches = location.hash.match(/filter=([^&]+)/i);

    if (!matches) {
      return '';
    }

    return decodeURIComponent(matches[1]);
  }

  if (getFilters()) {
    var filters = getFilters().split(',');
    filters.forEach(function (filter) {
      var $checkbox = checkboxes.filter("[value='".concat(filter, "']"));
      $checkbox.attr('checked', 'checked');
    });
  }

  $('.option-set input[type=checkbox]').each(function () {
    var label = $(this).next('label').text().replace("'", '');

    if ($(this).is(':checked')) {
      $("<span>".concat(label, " /</span>")).appendTo('.filters-current');
    }
  });
  onChange();
});